import Loading from '../../../Common/Loading';
import { Disabilities } from './Disabilities';
import { DisabilitiesPercentage } from './DisabilitiesPercentage';
import { Indicators } from './Indicators';
import { PeopleWithDisabilitiesIndicator } from './PeopleWithDisabilitiesIndicator';
import { usePeopleWithDisabilitiesChartsDataContext } from './hooks/usePeopleWithDisabilitiesChartsDataContext';

export const Charts = () => {
    const { isLoading } = usePeopleWithDisabilitiesChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <div className="charts-side-by-side-dashboards">
                <Indicators />
                <PeopleWithDisabilitiesIndicator />
            </div>
            <div className="charts-side-by-side-dashboards">
                <DisabilitiesPercentage />
                <Disabilities />
            </div>
        </>
    );
};
